<template>
  <v-row>
    <v-col cols="12" md="4">
      <v-autocomplete
        v-no-autofill
        :value="addressId"
        :items="addressItems"
        item-text="label"
        item-value="id"
        :label="label"
        :disabled="disabled"
        :loading="loading"
        clearable
        @change="$emit('update:addressId', $event)"
      />
    </v-col>
    <v-col cols="12" md="5">
      <v-textarea
        :value="addressText"
        rows="2"
        auto-grow
        :label="$t('COMPANIES.ADDRESS')"
        :disabled="disabled"
        @input="$emit('update:addressText', $event)"
      />
    </v-col>
    <v-col cols="12" md="3">
      <v-autocomplete
        v-no-autofill
        :value="countryId"
        :items="countries"
        item-text="label"
        item-value="id"
        :label="$t('GENERAL.LABELS.COUNTRY')"
        :disabled="disabled"
        clearable
        @change="$emit('update:countryId', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { GET_COMPANY_ADDRESSES } from "@/store/companies.module";
import { GET_COUNTRIES } from "@/store/countries.module";

export default {
  name: "StockOrderAddressPicker",
  props: {
    companyId: { type: [Number, String], default: null },
    addressId: { type: [Number, String], default: null },
    addressText: { type: String, default: null },
    countryId: { type: [Number, String], default: null },
    label: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    preferDefault: { type: String, default: "is_default_delivery" },
  },
  data() {
    return {
      addresses: [],
      countries: [],
      loading: false,
    };
  },
  computed: {
    addressItems() {
      return this.addresses.map((address) => ({
        id: address.id,
        label: [address.label, address.city, address.country?.name].filter(Boolean).join(" · ")
          || address.formatted
          || address.address,
      }));
    },
  },
  watch: {
    companyId: {
      immediate: true,
      handler(id, previous) {
        this.loadAddresses();
        if (previous && id !== previous) {
          this.$emit("update:addressId", null);
        }
      },
    },
    addressId(id) {
      const address = this.addresses.find((row) => Number(row.id) === Number(id));
      if (!address) {
        return;
      }
      this.$emit("update:addressText", address.formatted || address.address);
      if (address.country_id) {
        this.$emit("update:countryId", address.country_id);
      }
    },
  },
  mounted() {
    this.$store.dispatch(GET_COUNTRIES).then((response) => {
      this.countries = Array.isArray(response) ? response : (response.data || []);
    });
  },
  methods: {
    async loadAddresses() {
      if (!this.companyId) {
        this.addresses = [];
        return;
      }
      this.loading = true;
      try {
        this.addresses = await this.$store.dispatch(GET_COMPANY_ADDRESSES, this.companyId);
        if (!this.addressId) {
          const preferred = this.addresses.find((row) => row[this.preferDefault]);
          if (preferred) {
            this.$emit("update:addressId", preferred.id);
          }
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
